import { default as General } from './General'

export default General
